import React from 'react';
import { FaTools, FaHardHat } from 'react-icons/fa';

const Maintenance = () => {
  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center p-5 shadow-sm bg-white" style={{ borderRadius: '20px', maxWidth: '500px' }}>
        <div className="mb-4 text-primary">
          <FaHardHat size={60} className="mb-3" />
          <h2 className="fw-bold">Under Construction</h2>
        </div>
        
        <h4 className="text-dark mb-3">SiteWise Pro is getting an upgrade.</h4>
        
        <p className="text-muted mb-4">
          We are currently deploying new safety features and optimizing your dashboard. 
          We’ll be back online shortly. Stay safe!
        </p>

        <div className="d-flex align-items-center justify-content-center gap-2 text-primary fw-bold">
          <FaTools />
          <span>Scheduled Maintenance in Progress</span>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;